import React, { useState } from "react";
import axios from "axios";
import "../ApplyNowSteps/LoanForm.css";
import SelfieCapture from "./SelfieCapture";
import STATE_CITY from "../../utils/stateCityMapping";
import { useNavigate } from "react-router-dom";

// ===========================================================================
// ✔ LOAN FORM (FINAL STEP)
// ===========================================================================
const LoanForm = ({ autofillData, onBack }) => {
  const navigate = useNavigate();
  const [pan, setPan] = useState("");
  const [panStatus, setPanStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // Aadhaar Autofill Values
  const [firstName] = useState(autofillData.firstName || "");
  const [lastName] = useState(autofillData.lastName || "");
  const [mobile] = useState(autofillData.mobile || "");
  const [dob] = useState(autofillData.dob || "");
  const [address] = useState(autofillData.address || "");
  const [state] = useState(autofillData.state || "");
  const [city] = useState(autofillData.district || "");
  const [pincode] = useState(autofillData.pincode || "");
  const [gender] = useState(autofillData.gender || "");
  const [monthlyIncome, setMonthlyIncome] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [obligation, setObligation] = useState("");
  const [email] = useState(autofillData.email || "");
  // Document Uploads
  const [bankStatement, setBankStatement] = useState(null);
  const [salarySlip, setSalarySlip] = useState(null);
  const [utilityBill, setUtilityBill] = useState(null);

  const [stateId] = useState(autofillData.state_id || "");
  const [cityId] = useState(autofillData.city_id || "");

  // Selfie
  const [selfie, setSelfie] = useState("");
  const [showCameraModal, setShowCameraModal] = useState(false);

  const handleCapture = (img) => setSelfie(img);

  // PAN VERIFY
  const handlePanVerify = async (val) => {
    if (!val || val.length !== 10) return;

    try {
      const backendUrl = "https://fundswalla.in/loan_backend/verifyPan.php";

      const res = await axios.post(backendUrl, {
        pan: val,  // ✔ FIXED
      });

      if (res.data?.data?.responseCode === "SRC001") {
        setPanStatus("PAN Verification Complete!");
      } else {
        setPanStatus("Invalid PAN");
      }

    } catch (err) {
      setPanStatus("PAN Verification Error");
    }
  };


  const handleIncomeChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      if (value.length <= 8) {        // BLOCK after 8 digits
        setMonthlyIncome(value);
      }
    }
  };

 const handleLoanAmountChange = (e) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) {
    if (value.length <= 10) {        // BLOCK after 10 digits
      setLoanAmount(value);
    }
  }
};

const handleObligationChange = (e) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) {
    if (value.length <= 7) {         // BLOCK after 7 digits
      setObligation(value);
    }
  }
};


  // ===========================================================================
  // ✔ FINAL SUBMIT – STATIC PAYLOAD + Aadhaar Autofill + Selfie
  // ===========================================================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // -----------------------------------------------------
    //  REQUIRED VALIDATION
    // -----------------------------------------------------
    if (!pan || pan.length !== 10 || panStatus === "Invalid PAN") {
      alert("Please enter a valid 10-digit PAN number.");
      return;
    }

    if (!monthlyIncome || Number(monthlyIncome) <= 0) {
      alert("Please enter valid Monthly Income.");
      return;
    }

    if (!loanAmount || Number(loanAmount) <= 0) {
      alert("Please enter valid Loan Amount.");
      return;
    }

    if (obligation === "" || Number(obligation) < 0) {
      alert("Please enter your existing EMI obligations. Enter 0 if none.");
      return;
    }

    // if (!bankStatement) {
    //   alert("Bank Statement (PDF) is required.");
    //   return;
    // }

    if (!salarySlip) {
      alert("Salary Slip is required.");
      return;
    }

    if (!utilityBill) {
      alert("Electricity / Gas Bill is required.");
      return;
    }

    if (!selfie) {
      alert("Selfie is required.");
      return;
    }

    const payload = {
      customer_id: "",
      loan_amount: loanAmount,
      monthly_income: monthlyIncome,
      obligations: obligation,
      state_id: stateId,
      city: cityId,
      pincode: pincode,
      first_name: firstName,
      middle_name: lastName,
      gender: gender === "MALE" ? "M" : gender === "FEMALE" ? "F" : "O",
      dob: dob,
      pan: pan,
      mobile: mobile,
      email_personal: email,
      source: pincode,
    };

    const base64ToFile = (base64, filename = null) => {
      if (!base64) return null;

      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      const finalName =
        filename || `document_${Date.now()}.${mime.split("/")[1]}`;

      return new File([u8arr], finalName, { type: mime });
    };


    
       

    console.log("FINAL PAYLOAD:", payload);

    try {
      const res = await axios.post("https://fundswalla.in/loan_backend/saveLendingPage.php", payload);

      console.log("SAVE RESPONSE:", res.data);
      const lead_id = res.data.inserted_id;
      const status = res.data.status ?? res.data.Status;
      const message = res.data.message ?? res.data.Message;

      const selfieFile = selfie ? base64ToFile(selfie, "selfie.jpg") : null;

      const formData = new FormData();
      formData.append("lead_id", lead_id);
      formData.append("pan", pan);
      formData.append("mobile", mobile);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("dob", dob);
      formData.append("address", address);
      formData.append("stateId", stateId);
      formData.append("cityId", cityId);
      formData.append("pincode", pincode);
      formData.append("gender", gender);
      formData.append("monthlyIncome", monthlyIncome);
      formData.append("loanAmount", loanAmount);
      formData.append("obligation", obligation);
      formData.append("email", email);
      formData.append("state", state);
      formData.append("city", city);
      // ...existing code...

      // ...existing code...

      if (selfieFile) formData.append("selfie", selfieFile);
      if (bankStatement) formData.append("bank_statement", bankStatement);
      if (salarySlip) formData.append("salary_slip", salarySlip);
      if (utilityBill) formData.append("utility_bill", utilityBill);

      if (status == 1) {
        const saveRes = await axios.post("https://fundswalla.in/loan_backend/submit.php",formData,{
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

    console.log("SAVE RESPONSE:", saveRes.data);

    const savedBankPath = saveRes.data.savedBankPath;

    // if (!savedBankPath) {
    //   alert("Document upload failed. Please try again.");
    //   return;
    // }

   let referenceId = null;

if (savedBankPath) {
  const uploadRes = await axios.post(
    "https://fundswalla.in/loan_backend/uploadBankStatement.php",
    { filePath: savedBankPath }
  );

  referenceId =
    uploadRes.data?.data?.referenceId ||
    uploadRes.data?.referenceId ||
    null;
}

// if (savedBankPath && !referenceId) {
//   alert("Bank statement processing failed. Please upload a valid PDF and try again.");
//   return;
// }


    navigate("/thank-you");

    // ReferenceId received successfully, continuing to fetch BSA report...

    // ==================== WAIT FOR BSA REPORT ====================
    const getBsaReportWithWait = async (referenceId, setLoading) => {
      setLoading(true);

      const maxAttempts = 300; // 300 × 3 sec = 15 minutes max
      let attempt = 0;

      while (attempt < maxAttempts) {
        attempt++;

        console.log(`Fetching BSA Report… Attempt ${attempt}`);

        const res = await axios.get(
          "https://fundswalla.in/loan_backend/getBsaReport.php",
          {
            params: { referenceId },
            timeout: 45000,
          }
        );

        const data = res.data;

        // Report READY
        if (data?.data?.excelUrl) {
          setLoading(false);
          return data;
        }

        // ScoreMe still processing
        if (data?.responseCode === "RNP020") {
          console.log("Report still processing… waiting 3 sec…");
          await new Promise((resolve) => setTimeout(resolve, 3000));
          continue;
        }

        break;
      }

      setLoading(false);
      return null;
    };

    setLoading(true);

    // FETCH REPORT
    const reportData = await getBsaReportWithWait(referenceId, setLoading);

    if (!reportData) {
      alert("Your application is being processed. Please check back in a few minutes.");
      return;
    }

    const excelUrl = reportData.data.excelUrl;
    const jsonUrl = reportData.data.jsonUrl;

    // Send to DB
    const updatepayload = {
      excelUrl: excelUrl,
      lead_id: lead_id,
    };

  
    console.log("UPDATE11111 PAYLOAD:", updatepayload);

    const res2 = await axios.post(
      "https://fundswalla.in/loan_backend/UpdateDocument.php",
      updatepayload,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    console.log("UPDATE RESPONSE:", res2.data);   
    
    // navigate("/thank-you");
  } else {
    alert(message || "Application could not be submitted. Please try again.");
  }

    } catch (err) {
      console.error("API Error:", err);
      alert("Something went wrong. Please check your internet connection and try again.");
    }

  };

  return (
    <div className="loanform-wrapper">
      <div className="loan-card">
        <form onSubmit={handleSubmit}>
          <h2 className="title">Loan Application</h2>

          <div className="form-grid">
            {/* Row 1: PAN, Income, Loan, Obligation */}
            <div className="form-item">
              <label>PAN Number</label>
              <input
                type="text"
                maxLength="10"
                placeholder="Enter PAN"
                value={pan}
                onChange={(e) => {
                  const v = e.target.value.toUpperCase();
                  setPan(v);
                  if (v.length === 10) handlePanVerify(v);
                }}
              />
              {panStatus && <p style={{ color: panStatus.includes("Complete") ? "#10b981" : "#ef4444", margin: "4px 0", fontSize: "0.75rem" }}>{panStatus}</p>}
            </div>

            <div className="form-item">
              <label>Monthly Income</label>
              <input type="text" value={monthlyIncome} onChange={handleIncomeChange} placeholder="₹ Monthly Income" />
            </div>

            <div className="form-item">
              <label>Loan Amount</label>
              <input type="text" value={loanAmount} onChange={handleLoanAmountChange} placeholder="₹ Required Amount" />
            </div>

            <div className="form-item">
              <label>EMI Obligations</label>
              <input type="text" value={obligation} onChange={handleObligationChange} placeholder="₹ Existing EMI" />
            </div>

            {/* Row 2: Names - wider fields */}
            <div className="form-item half-width">
              <label>First Name</label>
              <input value={firstName} disabled />
            </div>

            <div className="form-item half-width">
              <label>Last Name</label>
              <input value={lastName} disabled />
            </div>

            {/* Row 3: Contact Info */}
            <div className="form-item">
              <label>Mobile Number</label>
              <input value={mobile} disabled />
            </div>

            <div className="form-item">
              <label>Date of Birth</label>
              <input value={dob} disabled />
            </div>

            <div className="form-item">
              <label>Gender</label>
              <input value={gender} disabled />
            </div>

            <div className="form-item">
              <label>Pincode</label>
              <input value={pincode} disabled />
            </div>

            {/* Row 4: Location - wider fields */}
            <div className="form-item half-width">
              <label>State</label>
              <input value={state} disabled />
            </div>

            <div className="form-item half-width">
              <label>City / District</label>
              <input value={city} disabled />
            </div>

            {/* Row 5: Address (Full Width) */}
            <div className="form-item full-width">
              <label>Complete Address</label>
              <textarea rows="2" value={address} disabled />
            </div>

            {/* Row 6: Upload Files - wider */}
            <div className="form-item half-width upload-box">
              <label>Bank Statement (PDF)</label>
              <input type="file" onChange={(e) => setBankStatement(e.target.files[0])} accept="application/pdf" />
            </div>

            <div className="form-item half-width upload-box">
              <label>Salary Slip (PDF/Image)</label>
              <input type="file" onChange={(e) => setSalarySlip(e.target.files[0])} accept="image/*,application/pdf" />
            </div>

            <div className="form-item half-width upload-box">
              <label>Utility Bill (Electric/Gas)</label>
              <input type="file" onChange={(e) => setUtilityBill(e.target.files[0])} accept="image/*" />
            </div>

            {/* Selfie - Inline Layout */}
            <div className="form-item half-width">
              <label>Capture Selfie</label>
              <div style={{ display: "flex", alignItems: "center", gap: "15px", flexWrap: "wrap", marginTop: "4px" }}>
                <button type="button" className="btn-next" onClick={() => setShowCameraModal(true)}>
                  {selfie ? "📷 Retake Selfie" : "📷 Capture Selfie"}
                </button>
                {selfie && <img src={selfie} alt="selfie" style={{ width: "55px", height: "55px", borderRadius: "10px", border: "3px solid #0d9488", objectFit: "cover" }} />}
              </div>
            </div>
          </div>

          {loading && <div className="loader">⏳ Generating Report… Please wait…</div>}

          <div className="btn-row">
            <button type="submit" className="btn-next">Submit Application</button>
          </div>
        </form>

        <SelfieCapture show={showCameraModal} handleClose={() => setShowCameraModal(false)} onCapture={handleCapture} />
      </div>
    </div>
  );
};

const normalize = (str = "") => {
  return String(str)
    .toLowerCase()
    .replace(/[^a-zA-Z\s]/g, " ")   
    .replace(/\s+/g, " ")           
    .trim();                         
};

export const findStateCityIds = (stateName, cityName) => {
  const nState = normalize(stateName);
  const nCity = normalize(cityName);

  for (const key in STATE_CITY) {
    const state = STATE_CITY[key];
    const sName = normalize(state.state_name);

    if (nState === sName) {
      const stateId = state.state_id;

      for (const cityId in state.cities) {
        const cName = normalize(state.cities[cityId]);

        if (
          nCity === cName ||
          nCity.includes(cName) ||
          cName.includes(nCity)
        ) {
          return { stateId, cityId };
        }
      }

      return { stateId, cityId: "" };
    }
  }

  return { stateId: "", cityId: "" };
};

// ===========================================================================
// ✔ AADHAAR AUTOFILL SCREEN
// ===========================================================================
const AadharFulfill = ({ data, onBack }) => {
  const getFirstName = (n) => n?.split(" ")[0] || "";
  const getLastName = (n) => n?.split(" ").slice(1).join(" ") || "";
  const getMobile = () => {
  return localStorage.getItem("mobileNumber") || "";
};
  const getEmail = (d) => d.email || d.emailAddress || "";
  const getDob = (d) => d.dateOfBirth || d.dob || "";
  const { stateId, cityId } = findStateCityIds(data.state, data.district);


  const getAddress = (d) =>
    [
      d.house,
      d.street,
      d.landmark,
      d.locality,
      d.vtcName,
      d.district,
      d.state,
      d.pincode,
      d.country,
      d.address,
    ]
      .filter(Boolean)
      .join(", ");

  const [showLoanForm, setShowLoanForm] = useState(false);
  const [email, setEmail] = useState(getEmail(data));

  if (showLoanForm) {
    return (
      <LoanForm
        autofillData={{
          firstName: getFirstName(data.name),
          lastName: getLastName(data.name),
         mobile: localStorage.getItem("mobileNumber") || "",
          email: email,
          dob: getDob(data),
          address: getAddress(data),
          state: data.state,
          district: data.district,
          pincode: data.pincode,
          gender: data.gender || data.Gender || "",
          state_id: stateId,
          city_id: cityId,
        }}
        onBack={onBack}
      />
    );
  }

  return (
    <div className="aadhaar-new-wrapper">
      <h2>Aadhaar Details Autofill</h2>

      <div className="aadhaar-new-form-grid">
        <div className="aadhaar-new-form-item">
          <label>First Name</label>
          <input value={getFirstName(data.name)} disabled />
        </div>

        <div className="aadhaar-new-form-item">
          <label>Last Name</label>
          <input value={getLastName(data.name)} disabled />
        </div>

        <div className="aadhaar-new-form-item">
          <label>Mobile</label>
         <input value={getMobile()} disabled />
          {/* <input
            value={mobile}
            maxLength={10}
            onChange={(e) =>
              /^\d*$/.test(e.target.value) && setMobile(e.target.value)
            }
          /> */}
        </div>

        <div className="aadhaar-new-form-item">
          <label>Email</label>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="aadhaar-new-form-item">
          <label>DOB</label>
          <input value={getDob(data)} disabled />
        </div>

        <div className="aadhaar-new-form-item aadhaar-new-full-width">
          <label>Address</label>
          <textarea rows="3" value={getAddress(data)} disabled />
        </div>
      </div>

      <button
  className="aadhaar-new-btn-next"
  onClick={() => {
    const mobileNumber = getMobile();

    if (!mobileNumber || mobileNumber.length !== 10) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    setShowLoanForm(true);
  }}
>
  Continue
</button>

    </div>
  );
};



// ===========================================================================
// ✔ OTP VERIFICATION SCREEN
// ===========================================================================

const OtpVerification = ({ onBack, onNext }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [aadhaarData, setAadhaarData] = useState(null);

  const aadhaarNumber = localStorage.getItem("aadhaarNumber");

const verifyOtp = async () => {
  if (!otp) return alert("Please enter the OTP sent to your mobile.");

  setLoading(true);
  try {
    const backendUrl = "https://fundswalla.in/loan_backend/verifyAadhaarOtp.php";

    const payload = {
      aadhaar_number: localStorage.getItem("aadhaarNumber"),
      otp: otp
    };

    console.log("VERIFY PAYLOAD:", payload);

    const res = await axios.post(backendUrl, payload);
    console.log("VERIFY RESPONSE:", res.data);

    if (res.data?.data?.responseCode === "SRC001" || res.data?.data?.responseMessage === "Successfully Completed.") {
      setVerified(true);
      setAadhaarData(res.data?.data?.data); // Aadhaar details inside "data"    
    if (onNext) onNext();
    } else {
        alert("Incorrect OTP. Please try again.");
    }
  } catch (err) {
    console.error(err);
    alert("OTP verification failed. Please check your internet connection and try again.");
  }
  setLoading(false);
};



  if (verified) {
    return <AadharFulfill data={aadhaarData} onBack={onBack} />;
  }

  return (
    <div className="aadhaar-page-wrapper">
      <div className="aadhaar-card">
        <div className="aadhaar-icon">🔑</div>
        <h3 className="aadhaar-title">Verify OTP</h3>
        <p className="aadhaar-subtitle">
          OTP sent to ******{String(aadhaarNumber).slice(-4)}
        </p>

        <input
          type="text"
          maxLength={6}
          value={otp}
          placeholder="Enter 6-digit OTP"
          onChange={(e) => /^\d*$/.test(e.target.value) && setOtp(e.target.value)}
          className={`aadhaar-input ${otp.length === 6 ? "valid" : ""}`}
        />

        <button
          className={`aadhaar-btn ${otp.length === 6 ? "active" : "disabled"}`}
          disabled={otp.length !== 6 || loading}
          onClick={verifyOtp}
        >
          {loading ? "Verifying..." : "VERIFY OTP"}
        </button>

        <p className="aadhaar-note">
          Didn't receive OTP? Request again after 30 seconds.
        </p>
      </div>
    </div>
  );
};

export default OtpVerification;
